import React, { useEffect, useRef, useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import { useAppState } from '../../state';
export default function TestSpeakerButton(props: { className?: string }) {
	const { activeSinkId } = useAppState();
	const audio = useRef<HTMLAudioElement>();
	const generation = useRef(0);
	const [message, setMessage] = useState('');
	useEffect(() => {
		const stop = () => {
			generation.current++;
			audio.current?.pause();
			audio.current = undefined;
		};
		window.addEventListener('speaker-test-start', stop);
		return () => {
			stop();
			window.removeEventListener('speaker-test-start', stop);
		};
	}, [activeSinkId]);
	const test = async () => {
		window.dispatchEvent(new Event('speaker-test-start'));
		const attempt = generation.current;
		const player = new Audio(
			`${process.env.PUBLIC_URL || ''}/sounds/speaker-test.wav`,
		);
		audio.current = player;
		setMessage('');
		try {
			if (player.setSinkId) await player.setSinkId(activeSinkId);
			else setMessage('Playing through your system speaker.');
			if (attempt !== generation.current) return;
			await player.play();
		} catch {
			if (attempt === generation.current)
				setMessage(
					'Unable to play the test sound. Check your speaker and try again.',
				);
		}
	};
	return (
		<div>
			<Button
				onClick={test}
				className={props.className}
				startIcon={<VolumeUpIcon />}
			>
				Test speaker
			</Button>
			{message && (
				<Typography role="status" variant="body2">
					{message}
				</Typography>
			)}
		</div>
	);
}
